import HttpService from '@/services/HttpService';
import { error } from '@/utils/error';
import { CLIENT_CONTROLLER } from '@/constants';
const getContent = async (brand) => {
    const path = `/clientcontroller/salesfunnelclient/ophalenrenderinfo?propositie=${brand}`;
    const { data } = (await HttpService.get(path));
    if (data.taal === undefined) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path,
            brand
        });
    }
    return data;
};
export default {
    getContent
};
